/* unplugin-vue-components disabled */import __unplugin_components_1 from 'D:/workspace/space-time-web/src/components/Pagination/index.vue';
import __unplugin_components_0 from 'D:/workspace/space-time-web/src/components/RightToolbar/index.vue';
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, isRef as _isRef, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/add.png';
const _hoisted_1 = {
  class: "page"
};
const _hoisted_2 = {
  class: "ele-wrapper-bgCard"
};
const _hoisted_3 = {
  class: "app-container"
};
const _hoisted_4 = {
  class: "infolist"
};
const _hoisted_5 = {
  class: "infotime"
};
const _hoisted_6 = {
  class: "comp-style"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "comp-style"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "comp-style"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "comp-style"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "dialog-footer"
};
import add from './add';
import { listProject, getProject, addProject, updateProject, delProject, selectProjectReportnoList, defaultalarmtype, addorupdateprojectreportno } from "@/api/base/project";
export default {
  __name: 'index',
  setup(__props) {
    provide("getMessage", getProjectReportNoList);
    const {
      proxy
    } = getCurrentInstance();
    const projectList = ref([]);
    const open = ref(false);
    const showSearch = ref(true);
    const ids = ref([]);
    const single = ref(true);
    const multiple = ref(true);
    const total = ref(0);
    const title = ref("");
    const projectReportNoList = ref([]);
    const defaultAlarmTypes = ref([]);
    const colorMap = ref(new Map());
    const predefineColors = ref(["#409EFF", "#ff4500", "#ff8c00", "#ffd700", "#90ee90", "#00ced1", "#1e90ff", "#c71585"]);
    const data = reactive({
      form: {},
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        projectName: undefined
      },
      rules: {
        projectName: [{
          required: true,
          message: '方案名称不能为空',
          trigger: 'blur'
        }, {
          min: 2,
          max: 20,
          message: '方案名称长度必须介于 2 和 20 之间',
          trigger: 'blur'
        }]
      }
    });
    const {
      queryParams,
      form,
      rules
    } = toRefs(data);
    function getProjectReportNoList() {
      selectProjectReportnoList().then(response => {
        projectReportNoList.value = response.data;
        colorMap.value = new Map();
        if (projectReportNoList.value.length > 0) {
          projectReportNoList.value.map(item => {
            if (item.reportColor !== undefined && item.reportColor !== null && item.reportColor !== '') {
              colorMap.value.set(item.projectId + "_" + item.reportLevel, item.reportColor);
            }
          });
        }
      });
    }
    function getDefaultAlarmType() {
      defaultalarmtype().then(response => {
        defaultAlarmTypes.value = response.data;
      });
    }
    function colorChange(color, projectId, reportLevel) {
      colorMap.value.set(projectId + "_" + reportLevel, color);
      updataWorkConfig(projectId, reportLevel, color);
    }
    function updataWorkConfig(projectId, reportLevel, color) {
      let types = '';
      if (projectReportNoList.value.length > 0) {
        projectReportNoList.value.map(item => {
          if (item.projectId === projectId && item.reportLevel === reportLevel) {
            types += item.type + ',';
          }
        });
      }
      if (types === '') {
        return;
      }
      let formData = {
        projectId: projectId,
        reportLevel: reportLevel,
        reportColor: color,
        types: types
      };
      addorupdateprojectreportno(JSON.stringify(formData)).then(response => {
        proxy.$forceUpdate();
        getProjectReportNoList();
      });
    }
    function getAddShow(row, reportLevel) {
      proxy.$refs["addRef"].getshow(row.projectId, row.projectName, reportLevel, colorMap.value.get(row.projectId + "_" + reportLevel), defaultAlarmTypes.value, projectReportNoList.value);
    }
    function getCurentType(projectId, reportLevel) {
      let typeName = '';
      if (projectReportNoList.value.length > 0) {
        projectReportNoList.value.map(item => {
          if (item.projectId === projectId && item.reportLevel === reportLevel) {
            typeName += item.reportName + "，";
          }
        });
      }
      if (projectId !== undefined && reportLevel !== undefined && !colorMap.value.get(projectId + "_" + reportLevel)) {
        if (reportLevel === 1) {
          colorMap.value.set(projectId + "_" + reportLevel, '#ff4500');
        } else if (reportLevel === 2) {
          colorMap.value.set(projectId + "_" + reportLevel, '#ff8c00');
        } else if (reportLevel === 3) {
          colorMap.value.set(projectId + "_" + reportLevel, '#ffd700');
        } else {
          colorMap.value.set(projectId + "_" + reportLevel, '#90ee90');
        }
      }
      return typeName.substring(0, typeName.length - 1);
    }
    function getList() {
      listProject(queryParams.value).then(response => {
        projectList.value = response.rows;
        total.value = response.total;
      });
    }
    /** 搜索按钮操作 */
    function handleQuery() {
      queryParams.value.pageNum = 1;
      getList();
    }
    /** 重置按钮操作 */
    function resetQuery() {
      proxy.resetForm("queryRef");
      handleQuery();
    }
    /** 删除按钮操作 */
    function handleDelete(row) {
      const projectIds = row.projectId || ids.value;
      const names = proxy.getNames(projectIds, projectList.value, "projectId", "projectName");
      proxy.$modal.confirm('是否确认删除识别方案名称为"' + names + '"的数据项?').then(function () {
        return delProject(projectIds);
      }).then(() => {
        getList();
        proxy.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    }

    /** 多选框选中数据 */
    function handleSelectionChange(selection) {
      ids.value = selection.map(item => item.projectId);
      single.value = selection.length != 1;
      multiple.value = !selection.length;
    }

    /** 重置新增的表单以及其他数据  */
    function reset() {
      form.value = {
        projectId: undefined,
        projectName: undefined,
        remark: undefined
      };
      proxy.resetForm("projectRef");
    }
    /** 添加方案 */
    function handleAdd() {
      reset();
      open.value = true;
      title.value = '添加识别方案';
    }
    /** 修改方案 */
    function handleUpdate(row) {
      reset();
      const projectId = row.projectId || ids.value;
      getProject(projectId).then(response => {
        form.value = response.data;
        open.value = true;
        title.value = "修改识别方案";
      });
    }

    /** 提交按钮 */
    function submitForm() {
      proxy.$refs["projectRef"].validate(valid => {
        if (valid) {
          if (form.value.projectId != undefined) {
            updateProject(form.value).then(response => {
              proxy.$modal.msgSuccess("修改成功");
              open.value = false;
              getList();
            });
          } else {
            addProject(form.value).then(response => {
              proxy.$modal.msgSuccess("新增成功");
              open.value = false;
              getList();
            });
          }
        }
      });
    }
    /** 取消按钮 */
    function cancel() {
      open.value = false;
      reset();
    }
    getList();
    getProjectReportNoList();
    getDefaultAlarmType();
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_col = _resolveComponent("el-col");
      const _component_right_toolbar = __unplugin_components_0;
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_color_picker = _resolveComponent("el-color-picker");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_table = _resolveComponent("el-table");
      const _component_pagination = __unplugin_components_1;
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createVNode(_component_el_form, {
        model: _unref(queryParams),
        ref: "queryRef",
        inline: true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "方案名称",
          prop: "projectName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(queryParams).projectName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(queryParams).projectName = $event),
            placeholder: "请输入方案名称",
            clearable: "",
            style: {
              "width": "24rem"
            },
            onKeyup: _withKeys(handleQuery, ["enter"])
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "satpro-button",
            icon: "Search",
            onClick: handleQuery
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("搜索", -1)]))]),
            _: 1
          }), _createVNode(_component_el_button, {
            class: "satpro-button",
            icon: "Refresh",
            onClick: resetQuery
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("重置", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), [[_vShow, _unref(showSearch)]]), _createVNode(_component_el_row, {
        gutter: 10,
        class: "mb8"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 1.5
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "satpro-button",
            plain: "",
            icon: "Plus",
            onClick: handleAdd
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("新增", -1)]))]),
            _: 1
          })), [[_directive_hasPermi, ['alarm:project:add']]])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 1.5
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "satpro-button",
            plain: "",
            icon: "Edit",
            disabled: _unref(single),
            onClick: handleUpdate
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("修改", -1)]))]),
            _: 1
          }, 8, ["disabled"])), [[_directive_hasPermi, ['alarm:project:edit']]])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 1.5
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "satpro-button",
            plain: "",
            icon: "Delete",
            disabled: _unref(multiple),
            onClick: handleDelete
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("删除", -1)]))]),
            _: 1
          }, 8, ["disabled"])), [[_directive_hasPermi, ['alarm:project:remove']]])]),
          _: 1
        }), _createVNode(_component_right_toolbar, {
          showSearch: _unref(showSearch),
          "onUpdate:showSearch": _cache[1] || (_cache[1] = $event => _isRef(showSearch) ? showSearch.value = $event : null),
          onQueryTable: getList
        }, null, 8, ["showSearch"])]),
        _: 1
      }), _cache[14] || (_cache[14] = _createElementVNode("div", {
        class: "menu-name"
      }, [_createElementVNode("span", {
        class: "textinfo"
      }, "方案管理")], -1)), _createVNode(_component_el_table, {
        data: _unref(projectList),
        onSelectionChange: handleSelectionChange,
        "header-cell-style": {
          background: 'transparent !important',
          color: '#FFFFFF'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          label: "方案编号",
          prop: "projectId",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          label: "方案名称",
          prop: "projectName",
          "show-overflow-tooltip": true,
          width: "300"
        }), _createVNode(_component_el_table_column, {
          label: "方案明细",
          align: "left"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_color_picker, {
            "model-value": _unref(colorMap).get(scope.row.projectId + '_1'),
            predefine: _unref(predefineColors),
            onChange: val => {
              colorChange(val, scope.row.projectId, 1);
            }
          }, null, 8, ["model-value", "predefine", "onChange"])]), _createTextVNode(" 一级告警：" + _toDisplayString(getCurentType(scope.row.projectId, 1)), 1), _createElementVNode("img", {
            onClick: $event => getAddShow(scope.row, 1),
            src: _imports_0,
            alt: ""
          }, null, 8, _hoisted_7)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_color_picker, {
            "model-value": _unref(colorMap).get(scope.row.projectId + '_2'),
            predefine: _unref(predefineColors),
            onChange: val => {
              colorChange(val, scope.row.projectId, 2);
            }
          }, null, 8, ["model-value", "predefine", "onChange"])]), _createTextVNode(" 二级告警：" + _toDisplayString(getCurentType(scope.row.projectId, 2)), 1), _createElementVNode("img", {
            onClick: $event => getAddShow(scope.row, 2),
            src: _imports_0,
            alt: ""
          }, null, 8, _hoisted_9)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_10, [_createVNode(_component_el_color_picker, {
            "model-value": _unref(colorMap).get(scope.row.projectId + '_3'),
            predefine: _unref(predefineColors),
            onChange: val => {
              colorChange(val, scope.row.projectId, 3);
            }
          }, null, 8, ["model-value", "predefine", "onChange"])]), _createTextVNode(" 三级告警：" + _toDisplayString(getCurentType(scope.row.projectId, 3)), 1), _createElementVNode("img", {
            onClick: $event => getAddShow(scope.row, 3),
            src: _imports_0,
            alt: ""
          }, null, 8, _hoisted_11)]), _createElementVNode("p", null, [_createElementVNode("span", _hoisted_12, [_createVNode(_component_el_color_picker, {
            "model-value": _unref(colorMap).get(scope.row.projectId + '_4'),
            predefine: _unref(predefineColors),
            onChange: val => {
              colorChange(val, scope.row.projectId, 4);
            }
          }, null, 8, ["model-value", "predefine", "onChange"])]), _createTextVNode(" 四级告警：" + _toDisplayString(getCurentType(scope.row.projectId, 4)), 1), _createElementVNode("img", {
            onClick: $event => getAddShow(scope.row, 4),
            src: _imports_0,
            alt: ""
          }, null, 8, _hoisted_13)])])])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          "class-name": "small-padding fixed-width"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_tooltip, {
            content: "修改",
            placement: "top",
            "auto-close": 500
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
              type: "primary",
              link: "",
              icon: "Edit",
              onClick: $event => handleUpdate(scope.row)
            }, null, 8, ["onClick"]), [[_directive_hasPermi, ['alarm:project:edit']]])]),
            _: 2
          }, 1024), _createVNode(_component_el_tooltip, {
            content: "删除",
            placement: "top",
            "auto-close": 500
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
              type: "primary",
              link: "",
              icon: "Delete",
              onClick: $event => handleDelete(scope.row)
            }, null, 8, ["onClick"]), [[_directive_hasPermi, ['alarm:project:remove']]])]),
            _: 2
          }, 1024)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _withDirectives(_createVNode(_component_pagination, {
        total: _unref(total),
        page: _unref(queryParams).pageNum,
        "onUpdate:page": _cache[2] || (_cache[2] = $event => _unref(queryParams).pageNum = $event),
        limit: _unref(queryParams).pageSize,
        "onUpdate:limit": _cache[3] || (_cache[3] = $event => _unref(queryParams).pageSize = $event),
        onPagination: getList
      }, null, 8, ["total", "page", "limit"]), [[_vShow, _unref(total) > 0]]), _createVNode(_component_el_dialog, {
        title: _unref(title),
        modelValue: _unref(open),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _isRef(open) ? open.value = $event : null),
        width: "50rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        draggable: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("确 定", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("取 消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "projectRef",
          model: _unref(form),
          rules: _unref(rules),
          "label-width": "10rem"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "方案名称",
            prop: "projectName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).projectName,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(form).projectName = $event),
              placeholder: "请输入方案名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "备注"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).remark,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(form).remark = $event),
              type: "textarea",
              placeholder: "请输入内容"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["title", "modelValue"]), _createVNode(_unref(add), {
        ref: "addRef"
      }, null, 512)])])]);
    };
  }
};